
export const findFirstDuplicate = (arr) => {
  const dublicates = arr.reduce((acc, item) => ({
    ...acc,
    [item]: acc[item] !== undefined ? acc[item] + 1 : 0
  }), {});

  for (const key in dublicates) {
    if (dublicates[key] === 0) {
      delete dublicates[key]
    }
  }

  return dublicates;
};